var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-xs":""}},[(_vm.checkLogin === true)?_c('ShoppingCartUI'):_c('ShoppingCartLocalUI')],1)}
var staticRenderFns = []

export { render, staticRenderFns }